export enum AiMentionType {
  NOTE = 'note',
  FOLDER = 'folder',
  PORTAL_SECTION = 'portalSection',
  PORTAL_NOTE = 'portalNote',
  PORTAL_PAGE = 'portalPage',
  INPUT = 'input',
  WEBSITE_PAGE = 'websitePage',
}
